import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { useBancoPagamentoListaViewModel } from "../../viewModels/banco_pagamento_lista_view_model"
import { GenerateBancoPagamentoListaColumns } from "./columns"
import { BancoPagamento } from "../../../domain/models/banco_pagamento"
import { CadastroBancoPagamentoModal } from "./components/cadastro_banco_pagamento_modal"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"


export const BancoPagamentoLista = () => {

    const viewModel = useBancoPagamentoListaViewModel();

    const columnsDef = useMemo(() => {
        return GenerateBancoPagamentoListaColumns({
            onActionEdit: viewModel.handleBancoPagamentoEditOpenState,
            onActionDelete: viewModel.handleBancoPagamentoDeleteOpenState,
        });
    }, [
        viewModel.handleBancoPagamentoEditOpenState,
        viewModel.handleBancoPagamentoDeleteOpenState
    ]);


    return (
        <>
            {/*
             <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={

                    }
                />
            </PageTopBar> 
            */}

            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">



                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleNewBancoPagamento()}>
                                    Novo Banco
                                </PrimaryButton>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col md:p-4 px-5 pt-2">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Typography className="text-primary-green">
                        Cadastro de Banco
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        <h1 className="text-3xl font-medium text-black dark:text-white"> Cadastro de Banco</h1>
                        <RefreshButton onClick={viewModel.handleReload} />
                    </div>


                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                status={viewModel.filters.status}
                                ddlBancoPagamento={viewModel.ddlBancoPagamento}
                                selectedIdsBancoPagamento={viewModel.filters.idsBancoPagamento ?? []}
                                onStatusChange={viewModel.handleStatusChange}
                                onClearFilters={viewModel.handleClearFilters}
                                handleIdsBancoPagamentoChange={viewModel.handleIdsBancoPagamentoChange}

                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="banco_Pagamento_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: BancoPagamento) => row.idBancoPagamento}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.bancoPagamentoLista}
                                    rowCount={viewModel.bancoPagamentoLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idBancoPagamento'],
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <DeleteDialog
                                open={viewModel.openDeleteModal}
                                onClose={() => viewModel.handleBancoPagamentoDeleteOpenState(null, false)}
                                title={`Você realmente deseja excluir este item?`}
                                onDelete={viewModel.handleConfirmarDeletarBancoPagamento} />


                            <CadastroBancoPagamentoModal
                                open={viewModel.openBancoPagamentoCadastroModal}
                                saving={viewModel.saving}
                                hookForm={viewModel.hookForm}
                                bancoPagamento={viewModel.bancoPagamento}
                                onSubmit={viewModel.handleCadastroBancoPagamentoSubmit}
                                onClose={() => viewModel.handleBancoPagamentoEditOpenState(null, false)}
                                handleOpenChangeHistory={viewModel.handleOpenChangeHistory}

                            />

                            <ChangeHistoryModal
                                changeHistoryHandler={viewModel.changeHistory} />

                        </>
                    )
                }

            </div >
        </>
    )
}
